<template>
  <campaigns-list status="live" />
</template>

<script>
import CampaignsList from '@/modules/campaigns/components/CampaignsList'
export default {
  name: 'LiveCampaignsTab',
  components: { CampaignsList }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/LiveCampaignsTab.vue